module.exports = __webpack_public_path__ + "logo-shopware6.0b43216407c0f626e4a5190894b70793.svg";